<template lang="pug">
.robot-info.robot3
  #info-b1
    .bg-mask(:class="{zoomIn: isB1Visible}")
    .w
      .p1.delay3(:class="{fadeUp: isB1Visible}") 维拉3，定义AI智慧生活
      .p2.delay4(:class="{fadeUp: isB1Visible}") 既能认识环境与人，又能连接万物
      .p3.delay5(:class="{fadeUp: isB1Visible}") 自身环境认知 | 人体动态识别 | 万物互联中枢
      .p2.price.delay6(:class="{fadeUp: isB1Visible}") ¥39,999元/套
  #info-b2
    .w
      .p1.delay1(:class="{fadeUp: isB2Visible}") 全新升级的语音交互
      .p2.delay2(:class="{fadeUp: isB2Visible}") 宛若与一位伙伴在交流
      .p3.delay3(:class="{fadeUp: isB2Visible}")
        p 经过精挑细选，为机器人赋予1种近乎真人般的语音。强大的语音识别引擎，能够轻松听到5米范围内的指令。
        p 遴选业界优秀麦克风，打造360度覆盖的6麦阵列，在你和维拉说话的时候，“他”时刻都能够判别你在哪个方位，回应更贴心。
      .p4
        .item.delay4(:class="{fadeDown: isB2Visible}")
          p 精选语音
          span
            b 1
            | 种
        .item.delay5(:class="{fadeDown: isB2Visible}")
          p 远场识别
          span
            b 5
            | 米
        .item.delay6(:class="{fadeDown: isB2Visible}")
          p 阵列支持
          span
            b 6
            | 麦

  #info-b3
    .w
      .p1(:class="{fadeUp: isB3Visible}") 黑科技的一次完美体现
      .p2.delay1(:class="{fadeUp: isB3Visible}") 如家人般，熟悉家中每个角落
      .p3.delay2(:class="{fadeUp: isB3Visible}") 一键自主建图 | 随性定义位置 | 静默更新地图
      .loading(:class="{animation: isB3Visible}")
      img.map(v-if="isMobile", :class="{animation: isB3Visible}", src="../../../assets/mobile/3-info-b3-img1.png")
      img.map(v-else, :class="{animation: isB3Visible}", src="../../../assets/web/3-info-b3-img1.png")
  #info-b4
    .w
      .p1(:class="{fadeUp: isB4Visible}") 多模式人体认知
      .p2.delay1(:class="{fadeUp: isB4Visible}") 懂你的一言一行，更懂你的心
      .p3.delay2(:class="{fadeUp: isB4Visible}")
        img(src="../../../assets/web/3-info-b4-img1.png")
  //- #info-b5
  //-   .w
  //-     .p1(:class="{fadeUp: isB5Visible}") 随叫随到
  //-     .p2.delay1(:class="{fadeUp: isB5Visible}") 在你需要“他”的时候无需去找。
  //-     .msg.delay2(:class="{fadeUp: isB5Visible}") 维拉，过来一下
  //-     .info-b5-robot3.delay4(:class="{'info-b5-robot3-animation': isB5Visible}")
  //-     .msg.blue.delay14(:class="{fadeDown: isB5Visible}") 主人，有什么可以帮您？
  #info-b5
    .p1.deplay1(:class="{fadeUp: isB5Visible}")
      img(class="img1", src="../../../assets/web/dialog1.png")
      img(class="img2", src="../../../assets/web/dialog2.png")
      img(class="img3", src="../../../assets/web/dialog3.png")
    .info-b5-robot3.delay4(:class="{'info-b5-robot3-animation': isB5Visible}")
      img.img4(:class="{fadeDown: isB5Visible}", src="../../../assets/web/dialog4.png")
  #info-b6
    .w
      .p1(:class="{fadeUp: isB6Visible}")
        img(src="../../../assets/web/3-info-b6-img1.png")
      .p2.delay3(:class="{fadeUp: isB6Visible}") 为机器人赋予灵魂
      .list
        .item(v-for="n in 4", :class="['delay'+n, 'img'+n, {fadeDown: isB6Visible}]")
  #info-b7
    .w
      .p1(:class="{fadeUp: isB7Visible}") 连接爱，连接家
      .p2.delay1(:class="{fadeUp: isB7Visible}") 享受每一次与家人的见面
      .p3.delay2(:class="{fadeUp: isB7Visible}") 远程看家 | 跟随视频 | 亲情陪伴
  #info-b8
</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
      isB6Visible: false,
      isB7Visible: false,
      isB8Visible: false,
    }
  },
  computed: {},
  methods: {},
  created () {
    $(window).on('scroll', () => {
      this.isB1Visible = isVisible('#info-b1')
      this.isB2Visible = isVisible('#info-b2')
      this.isB3Visible = isVisible('#info-b3')
      this.isB4Visible = isVisible('#info-b4')
      this.isB5Visible = isVisible('#info-b5')
      this.isB6Visible = isVisible('#info-b6')
      this.isB7Visible = isVisible('#info-b7')
      this.isB8Visible = isVisible('#info-b8')
    })
  }
}
</script>

<style lang="stylus">
@import 'config'
.robot-info
  .w
    position relative
    .p1
      font-size 40px
      color #333
    .p2
      font-size 16px
      color #666
    .p3
      font-size 14px
      color #999
  &.robot3
    #info-b1
      position relative
      min-width 1200px
      height 800px
      overflow hidden
      .bg-mask
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background url('../../../assets/web/3-info-b1.jpg') no-repeat center
        background-size auto 100%
      .w
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        text-align center
        padding-top 100px
      .p2
        font-size 24px
        padding-top 10px
        padding-bottom 26px
      .price
        font-size 17px
    #info-b2
      min-width 1200px
      background #f5f7f9
      height 800px
      background url('../../../assets/web/3-info-b2.jpg') no-repeat 60% center
      background-size auto 100%
      .w
        padding 168px 0 0 60px
      .p1,.p2,.p3,.p4
        color #fff
      .p3
        padding 60px 0
        width 560px
        p
          text-indent 2em
          line-height 1.7
      .p4
        .item
          vertical-align top
          display inline-block
          margin-right 30px
          width 165px
          height 165px
          border-radius 100%
          text-align center
          border 2px solid #43e1ac
          p
            padding 30px 0 0px
          span
            color #43e1ac
            b
              font-size 72px
              font-weight normal
    #info-b3
      min-width 1200px
      height 800px
      background url('../../../assets/web/3-info-b3.jpg') no-repeat center
      background-size auto 100%
      .w
        position relative
        padding-top 70px
        text-align center
      .p1
        color #fff
      .p2
        color #fff
        padding 10px 0 20px
      .p3
        color #ccc
      .loading
        position absolute
        transform-origin center
        top 250px
        left 50%
        margin-left -220px
        width 440px
        height 440px
        opacity 0
        background url('../../../assets/web/3-info-b3-img2.png') no-repeat center
        &.animation
          animation loading 1s 1s forwards
      .map
        position absolute
        opacity 0
        top 250px
        left 60px
        &.animation
          animation map .5s 2s forwards
    #info-b4
      min-width 1200px
      height 800px
      background url('../../../assets/web/3-info-b4.jpg') no-repeat center
      background-size auto 100%
      .w
        text-align center
        padding-top 100px
      .p3
        margin-top 20px
    #info-b5
      min-width 1200px
      height 800px
      background url('../../../assets/web/3-info-b5.jpg') no-repeat center
      background-size auto 100%
      overflow hidden
      .p1 
        display flex
        margin-left -330px
        .img1
          width 308px
          height 63px
          margin-top 138px
          margin-left 1726px
        .img2 
          width 170px
          height 64px
          margin-top 216px
          margin-left -220px
        .img3 
          width 142px
          height 64px
          margin-top 302px
          margin-left -200px
      .info-b5-robot3
        width 353px
        height 352px
        opacity 0
        background url('../../../assets/web/robot3.png') no-repeat center
        background-size auto 100%
        margin-left 806px
        margin-top 80px
        .img4 
          width 286px
          height 63px
          margin-top -48px
          margin-left 175px
    #info-b6
      min-width 1200px
      height 800px
      background url('../../../assets/web/3-info-b6.jpg') no-repeat center
      background-size auto 100%
      .w
        position relative
        padding-top 80px
        text-align center
      .p2
        color #fff
      .list
        margin 140px 0 0 50px
        .item
          display inline-block
          width 500px
          height 200px
          background-repeat no-repeat
          background-position left top
          &:nth-child(1)
            background-image: url('../../../assets/web/3-info-b6-img2.png')
          &:nth-child(2)
            background-image: url('../../../assets/web/3-info-b6-img3.png')
          &:nth-child(3)
            background-image: url('../../../assets/web/3-info-b6-img4.png')
          &:nth-child(4)
            background-image: url('../../../assets/web/3-info-b6-img5.png')

    #info-b7
      min-width 1200px
      height 800px
      background url('../../../assets/web/3-info-b7.jpg') no-repeat center
      background-size auto 100%
      .w
        padding 210px 0 0 190px
      .p2
        margin-bottom 20px
    #info-b8
      min-width 1200px
      height 777px
      background url('../../../assets/web/3-info-b8.jpg') no-repeat center
      background-size auto 100%
.is-mobile
  .robot3
    #info-b1, #info-b2, #info-b3, #info-b4, #info-b5, #info-b6, #info-b7, #info-b8
      width 100%
      min-width inherit
      height r(1100)
    #info-b1
      .bg-mask
        background-image url('../../../assets/mobile/3-info-b1.jpg')
      .w
        padding r(100) 0 0 0
      .p2
        font-size r(30)
    #info-b2
      background-image url('../../../assets/mobile/3-info-b2.jpg')
      .w
        padding r(40) r(40) 0
      .p3
        width 100%
        padding r(50) 0
        font-size r(22)
      .p4
        text-align center
        .item
          width r(165)
          height r(165)
          margin 0
          &:nth-child(2)
            margin 0 r(60)
          p
            padding r(30) 0 0
            font-size r(24)
          span
            b
              font-size r(60)
    #info-b3
      background-image url('../../../assets/mobile/3-info-b3.jpg')
      .w
        padding r(80) 0 0 0
      .loading
        top r(400)
        left r((750 - 440)/2)
        margin-left 0
        width r(440)
        height r(440)
        background-size cover
      .map
        width r(374)
        top r(340)
        left r((750 - 374)/2)

    #info-b4
      background-image url('../../../assets/mobile/3-info-b4.jpg')
      .w
        padding-top r(100)
        .p3
          img
            width 55%
    #info-b5
      background-image url('../../../assets/mobile/3-info-b5.jpg')
      .p1 
        display flex
        margin-left 0px
        .img1
          width 137px
          height 28px
          margin-top 186px
          margin-left 231px
        .img2 
          width 76px
          height 28px
          margin-top 221px
          margin-left -98px
        .img3 
          width 63px
          height 28px
          margin-top 259px
          margin-left -87px
      .info-b5-robot3
        width 180px
        height 180px
        opacity 0
        background url('../../../assets/web/robot3.png') no-repeat center
        background-size auto 100%
        margin-left 58px
        margin-top 102px
        .img4 
          width 127px
          height 28px
          margin-top -12px
          margin-left 104px
    #info-b6
      background-image url('../../../assets/mobile/3-info-b6.jpg')
      .w
        padding r(100) 0 0
      .p1
        img
          width 90%
      .list
        margin r(40) 0 0 r(90)
        .item
          width 100%
          height r(130)
          margin 0 0 r(80)
          background-size auto 100%

    #info-b7
      background-image url('../../../assets/mobile/3-info-b7.jpg')
      .w
        padding r(100) 0 0 0
        text-align center
    #info-b8
      background-image url('../../../assets/mobile/3-info-b8.jpg')
  .robot-info
    .w
      .p1
        font-size r(46)
      .p2
        font-size r(24)
</style>



// WEBPACK FOOTER //
// src/views/robot/3/info.vue